/* tslint:disable */
/* eslint-disable */
/**
 * alcohol/customer/v1/api.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Alcoholcustomerv1BusinessHourSettings
 */
export interface Alcoholcustomerv1BusinessHourSettings {
    /**
     * 
     * @type {Array<Alcoholcustomerv1BusinessHours>}
     * @memberof Alcoholcustomerv1BusinessHourSettings
     */
    'businessHours'?: Array<Alcoholcustomerv1BusinessHours>;
}
/**
 * 
 * @export
 * @interface Alcoholcustomerv1BusinessHours
 */
export interface Alcoholcustomerv1BusinessHours {
    /**
     * 
     * @type {Alcoholcustomerv1BusinessHoursDayOfWeek}
     * @memberof Alcoholcustomerv1BusinessHours
     */
    'dayOfWeek'?: Alcoholcustomerv1BusinessHoursDayOfWeek;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1BusinessHours
     */
    'startHour'?: number;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1BusinessHours
     */
    'startMinute'?: number;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1BusinessHours
     */
    'endHour'?: number;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1BusinessHours
     */
    'endMinute'?: number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const Alcoholcustomerv1BusinessHoursDayOfWeek = {
    Unspecified: 'DAY_OF_WEEK_UNSPECIFIED',
    Monday: 'DAY_OF_WEEK_MONDAY',
    Tuesday: 'DAY_OF_WEEK_TUESDAY',
    Wednesday: 'DAY_OF_WEEK_WEDNESDAY',
    Thursday: 'DAY_OF_WEEK_THURSDAY',
    Friday: 'DAY_OF_WEEK_FRIDAY',
    Saturday: 'DAY_OF_WEEK_SATURDAY',
    Sunday: 'DAY_OF_WEEK_SUNDAY',
    PublicHoliday: 'DAY_OF_WEEK_PUBLIC_HOLIDAY'
} as const;

export type Alcoholcustomerv1BusinessHoursDayOfWeek = typeof Alcoholcustomerv1BusinessHoursDayOfWeek[keyof typeof Alcoholcustomerv1BusinessHoursDayOfWeek];


/**
 * 
 * @export
 * @interface Alcoholcustomerv1CancelOrderResponse
 */
export interface Alcoholcustomerv1CancelOrderResponse {
    /**
     * 
     * @type {boolean}
     * @memberof Alcoholcustomerv1CancelOrderResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1CancelOrderResponse
     */
    'errorMessage'?: string;
}
/**
 * 
 * @export
 * @interface Alcoholcustomerv1CustomerDetails
 */
export interface Alcoholcustomerv1CustomerDetails {
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1CustomerDetails
     */
    'mobilePhoneNumber'?: string;
    /**
     * 
     * @type {Alcoholcustomerv1VerificationState}
     * @memberof Alcoholcustomerv1CustomerDetails
     */
    'verificationState'?: Alcoholcustomerv1VerificationState;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1CustomerDetails
     */
    'verificationEpoch'?: number;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1CustomerDetails
     */
    'verificationExpiredEpoch'?: number;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1CustomerDetails
     */
    'currentRsaRestriction'?: string;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1CustomerDetails
     */
    'numberOfAlcoholInLastHour'?: number;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1CustomerDetails
     */
    'numberOfAlcoholInLast24Hours'?: number;
}


/**
 * 
 * @export
 * @interface Alcoholcustomerv1ListOrdersRequest
 */
export interface Alcoholcustomerv1ListOrdersRequest {
    /**
     * 
     * @type {Alcoholcustomerv1OrderStatus}
     * @memberof Alcoholcustomerv1ListOrdersRequest
     */
    'orderStatus'?: Alcoholcustomerv1OrderStatus;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1ListOrdersRequest
     */
    'perPage'?: number;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1ListOrdersRequest
     */
    'page'?: number;
}


/**
 * 
 * @export
 * @interface Alcoholcustomerv1ListOrdersResponse
 */
export interface Alcoholcustomerv1ListOrdersResponse {
    /**
     * 
     * @type {boolean}
     * @memberof Alcoholcustomerv1ListOrdersResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1ListOrdersResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Array<Alcoholcustomerv1Order>}
     * @memberof Alcoholcustomerv1ListOrdersResponse
     */
    'orders'?: Array<Alcoholcustomerv1Order>;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1ListOrdersResponse
     */
    'pageCount'?: number;
}
/**
 * 
 * @export
 * @interface Alcoholcustomerv1ListVendingMachinesResponse
 */
export interface Alcoholcustomerv1ListVendingMachinesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof Alcoholcustomerv1ListVendingMachinesResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1ListVendingMachinesResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Array<Alcoholcustomerv1VendingMachine>}
     * @memberof Alcoholcustomerv1ListVendingMachinesResponse
     */
    'vendingMachines'?: Array<Alcoholcustomerv1VendingMachine>;
}
/**
 * 
 * @export
 * @interface Alcoholcustomerv1LoginRequest
 */
export interface Alcoholcustomerv1LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1LoginRequest
     */
    'mobilePhoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface Alcoholcustomerv1LoginResponse
 */
export interface Alcoholcustomerv1LoginResponse {
    /**
     * 
     * @type {boolean}
     * @memberof Alcoholcustomerv1LoginResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1LoginResponse
     */
    'errorMessage'?: string;
}
/**
 * 
 * @export
 * @interface Alcoholcustomerv1Order
 */
export interface Alcoholcustomerv1Order {
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1Order
     */
    'uuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1Order
     */
    'createdEpoch'?: number;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1Order
     */
    'updatedEpoch'?: number;
    /**
     * 
     * @type {Alcoholcustomerv1OrderStatus}
     * @memberof Alcoholcustomerv1Order
     */
    'status'?: Alcoholcustomerv1OrderStatus;
    /**
     * 
     * @type {Alcoholcustomerv1VendingMachine}
     * @memberof Alcoholcustomerv1Order
     */
    'vendingMachine'?: Alcoholcustomerv1VendingMachine;
    /**
     * 
     * @type {Alcoholcustomerv1Selection}
     * @memberof Alcoholcustomerv1Order
     */
    'selection'?: Alcoholcustomerv1Selection;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1Order
     */
    'surcharge'?: number;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1Order
     */
    'discount'?: number;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1Order
     */
    'failedReason'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const Alcoholcustomerv1OrderStatus = {
    Unspecified: 'ORDER_STATUS_UNSPECIFIED',
    PendingSelection: 'ORDER_STATUS_PENDING_SELECTION',
    PendingCustomerConfirm: 'ORDER_STATUS_PENDING_CUSTOMER_CONFIRM',
    Vending: 'ORDER_STATUS_VENDING',
    Failure: 'ORDER_STATUS_FAILURE',
    Aborted: 'ORDER_STATUS_ABORTED',
    VendedSuccess: 'ORDER_STATUS_VENDED_SUCCESS',
    ProcessingByVendcoin: 'ORDER_STATUS_PROCESSING_BY_VENDCOIN'
} as const;

export type Alcoholcustomerv1OrderStatus = typeof Alcoholcustomerv1OrderStatus[keyof typeof Alcoholcustomerv1OrderStatus];


/**
 * 
 * @export
 * @interface Alcoholcustomerv1Selection
 */
export interface Alcoholcustomerv1Selection {
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1Selection
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1Selection
     */
    'productName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Alcoholcustomerv1Selection
     */
    'isSensitive'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1Selection
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1Selection
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1Selection
     */
    'displayCode'?: string;
}
/**
 * 
 * @export
 * @interface Alcoholcustomerv1StartOrderRequest
 */
export interface Alcoholcustomerv1StartOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1StartOrderRequest
     */
    'vendingMachineUuid'?: string;
}
/**
 * 
 * @export
 * @interface Alcoholcustomerv1StartOrderResponse
 */
export interface Alcoholcustomerv1StartOrderResponse {
    /**
     * 
     * @type {boolean}
     * @memberof Alcoholcustomerv1StartOrderResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1StartOrderResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1StartOrderResponse
     */
    'orderUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof Alcoholcustomerv1StartOrderResponse
     */
    'timeout'?: number;
}
/**
 * 
 * @export
 * @interface Alcoholcustomerv1VendingMachine
 */
export interface Alcoholcustomerv1VendingMachine {
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1VendingMachine
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1VendingMachine
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1VendingMachine
     */
    'photoUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Alcoholcustomerv1VendingMachine
     */
    'isOnline'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1VendingMachine
     */
    'uuid'?: string;
    /**
     * 
     * @type {Alcoholcustomerv1BusinessHourSettings}
     * @memberof Alcoholcustomerv1VendingMachine
     */
    'alcoholBusinessHourSettings'?: Alcoholcustomerv1BusinessHourSettings;
    /**
     * 
     * @type {boolean}
     * @memberof Alcoholcustomerv1VendingMachine
     */
    'isAlcoholBusinessHourNow'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Alcoholcustomerv1VerificationState = {
    Unspecified: 'VERIFICATION_STATE_UNSPECIFIED',
    Verified: 'VERIFICATION_STATE_VERIFIED',
    Unverified: 'VERIFICATION_STATE_UNVERIFIED'
} as const;

export type Alcoholcustomerv1VerificationState = typeof Alcoholcustomerv1VerificationState[keyof typeof Alcoholcustomerv1VerificationState];


/**
 * 
 * @export
 * @interface Alcoholcustomerv1VerifyAuthCodeRequest
 */
export interface Alcoholcustomerv1VerifyAuthCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1VerifyAuthCodeRequest
     */
    'mobilePhoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1VerifyAuthCodeRequest
     */
    'authCode'?: string;
}
/**
 * 
 * @export
 * @interface Alcoholcustomerv1VerifyAuthCodeResponse
 */
export interface Alcoholcustomerv1VerifyAuthCodeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof Alcoholcustomerv1VerifyAuthCodeResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1VerifyAuthCodeResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alcoholcustomerv1VerifyAuthCodeResponse
     */
    'accessToken'?: string;
}
/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a URL that describes the type of the serialized message.  Protobuf library provides support to pack/unpack Any values in the form of utility functions or additional generated methods of the Any type.  Example 1: Pack and unpack a message in C++.      Foo foo = ...;     Any any;     any.PackFrom(foo);     ...     if (any.UnpackTo(&foo)) {       ...     }  Example 2: Pack and unpack a message in Java.      Foo foo = ...;     Any any = Any.pack(foo);     ...     if (any.is(Foo.class)) {       foo = any.unpack(Foo.class);     }     // or ...     if (any.isSameTypeAs(Foo.getDefaultInstance())) {       foo = any.unpack(Foo.getDefaultInstance());     }  Example 3: Pack and unpack a message in Python.      foo = Foo(...)     any = Any()     any.Pack(foo)     ...     if any.Is(Foo.DESCRIPTOR):       any.Unpack(foo)       ...  Example 4: Pack and unpack a message in Go       foo := &pb.Foo{...}      any, err := anypb.New(foo)      if err != nil {        ...      }      ...      foo := &pb.Foo{}      if err := any.UnmarshalTo(foo); err != nil {        ...      }  The pack methods provided by protobuf library will by default use \'type.googleapis.com/full.type.name\' as the type URL and the unpack methods only use the fully qualified type name after the last \'/\' in the type URL, for example \"foo.bar.com/x/y.z\" will yield type name \"y.z\".  JSON  The JSON representation of an `Any` value uses the regular representation of the deserialized, embedded message, with an additional field `@type` which contains the type URL. Example:      package google.profile;     message Person {       string first_name = 1;       string last_name = 2;     }      {       \"@type\": \"type.googleapis.com/google.profile.Person\",       \"firstName\": <string>,       \"lastName\": <string>     }  If the embedded message type is well-known and has a custom JSON representation, that representation will be embedded adding a field `value` which holds the custom JSON in addition to the `@type` field. Example (for message [google.protobuf.Duration][]):      {       \"@type\": \"type.googleapis.com/google.protobuf.Duration\",       \"value\": \"1.212s\"     }
 * @export
 * @interface ProtobufAny
 */
export interface ProtobufAny {
    [key: string]: object | any;

    /**
     * A URL/resource name that uniquely identifies the type of the serialized protocol buffer message. This string must contain at least one \"/\" character. The last segment of the URL\'s path must represent the fully qualified name of the type (as in `path/google.protobuf.Duration`). The name should be in a canonical form (e.g., leading \".\" is not accepted).  In practice, teams usually precompile into the binary all types that they expect it to use in the context of Any. However, for URLs which use the scheme `http`, `https`, or no scheme, one can optionally set up a type server that maps type URLs to message definitions as follows:  * If no scheme is provided, `https` is assumed. * An HTTP GET on the URL must yield a [google.protobuf.Type][]   value in binary format, or produce an error. * Applications are allowed to cache lookup results based on the   URL, or have them precompiled into a binary to avoid any   lookup. Therefore, binary compatibility needs to be preserved   on changes to types. (Use versioned type names to manage   breaking changes.)  Note: this functionality is not currently available in the official protobuf release, and it is not used for type URLs beginning with type.googleapis.com.  Schemes other than `http`, `https` (or the empty scheme) might be used with implementation specific semantics.
     * @type {string}
     * @memberof ProtobufAny
     */
    '@type'?: string;
}
/**
 * The `Status` type defines a logical error model that is suitable for different programming environments, including REST APIs and RPC APIs. It is used by [gRPC](https://github.com/grpc). Each `Status` message contains three pieces of data: error code, error message, and error details.  You can find out more about this error model and how to work with it in the [API Design Guide](https://cloud.google.com/apis/design/errors).
 * @export
 * @interface RpcStatus
 */
export interface RpcStatus {
    /**
     * The status code, which should be an enum value of [google.rpc.Code][google.rpc.Code].
     * @type {number}
     * @memberof RpcStatus
     */
    'code'?: number;
    /**
     * A developer-facing error message, which should be in English. Any user-facing error message should be localized and sent in the [google.rpc.Status.details][google.rpc.Status.details] field, or localized by the client.
     * @type {string}
     * @memberof RpcStatus
     */
    'message'?: string;
    /**
     * A list of messages that carry the error details.  There is a common set of message types for APIs to use.
     * @type {Array<ProtobufAny>}
     * @memberof RpcStatus
     */
    'details'?: Array<ProtobufAny>;
}
/**
 * 
 * @export
 * @interface V1GetOrderPaymentDataResponse
 */
export interface V1GetOrderPaymentDataResponse {
    /**
     * 
     * @type {boolean}
     * @memberof V1GetOrderPaymentDataResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof V1GetOrderPaymentDataResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {V1PaymentFormData}
     * @memberof V1GetOrderPaymentDataResponse
     */
    'paymentFormData'?: V1PaymentFormData;
}
/**
 * 
 * @export
 * @interface V1PaymentFormData
 */
export interface V1PaymentFormData {
    /**
     * 
     * @type {string}
     * @memberof V1PaymentFormData
     */
    'merchantUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PaymentFormData
     */
    'merchantPassword'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PaymentFormData
     */
    'merchantRefNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PaymentFormData
     */
    'currencyDesc'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PaymentFormData
     */
    'amount'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PaymentFormData
     */
    'transactionKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PaymentFormData
     */
    'notifyUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PaymentFormData
     */
    'processUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PaymentFormData
     */
    'cancelUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof V1PaymentFormData
     */
    'paymentUrl'?: string;
}
/**
 * 
 * @export
 * @interface V1RetrieveMyDetailsResponse
 */
export interface V1RetrieveMyDetailsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof V1RetrieveMyDetailsResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof V1RetrieveMyDetailsResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Alcoholcustomerv1CustomerDetails}
     * @memberof V1RetrieveMyDetailsResponse
     */
    'myDetails'?: Alcoholcustomerv1CustomerDetails;
}
/**
 * 
 * @export
 * @interface V1RetrieveOrderResponse
 */
export interface V1RetrieveOrderResponse {
    /**
     * 
     * @type {boolean}
     * @memberof V1RetrieveOrderResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof V1RetrieveOrderResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Alcoholcustomerv1Order}
     * @memberof V1RetrieveOrderResponse
     */
    'order'?: Alcoholcustomerv1Order;
}
/**
 * 
 * @export
 * @interface V1RetrieveVendingMachineDetailsResponse
 */
export interface V1RetrieveVendingMachineDetailsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof V1RetrieveVendingMachineDetailsResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof V1RetrieveVendingMachineDetailsResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Alcoholcustomerv1VendingMachine}
     * @memberof V1RetrieveVendingMachineDetailsResponse
     */
    'vendingMachine'?: Alcoholcustomerv1VendingMachine;
}

/**
 * OrderServiceApi - axios parameter creator
 * @export
 */
export const OrderServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel an order
         * @param {string} uuid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceCancelOrder: async (uuid: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('orderServiceCancelOrder', 'uuid', uuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('orderServiceCancelOrder', 'body', body)
            const localVarPath = `/api/customer/v1/orders/{uuid}/cancellations`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get HPS payment form data
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceGetOrderPaymentData: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('orderServiceGetOrderPaymentData', 'uuid', uuid)
            const localVarPath = `/api/customer/v1/orders/{uuid}/payment-form-data`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List customer orders
         * @param {Alcoholcustomerv1ListOrdersRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceListOrders: async (body: Alcoholcustomerv1ListOrdersRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('orderServiceListOrders', 'body', body)
            const localVarPath = `/api/customer/v1/list-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve order status by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceRetrieveOrder: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('orderServiceRetrieveOrder', 'uuid', uuid)
            const localVarPath = `/api/customer/v1/orders/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start an order on vending machine
         * @param {Alcoholcustomerv1StartOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceStartOrder: async (body: Alcoholcustomerv1StartOrderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('orderServiceStartOrder', 'body', body)
            const localVarPath = `/api/customer/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderServiceApi - functional programming interface
 * @export
 */
export const OrderServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel an order
         * @param {string} uuid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceCancelOrder(uuid: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Alcoholcustomerv1CancelOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceCancelOrder(uuid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get HPS payment form data
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceGetOrderPaymentData(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetOrderPaymentDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceGetOrderPaymentData(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List customer orders
         * @param {Alcoholcustomerv1ListOrdersRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceListOrders(body: Alcoholcustomerv1ListOrdersRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Alcoholcustomerv1ListOrdersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceListOrders(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve order status by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceRetrieveOrder(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RetrieveOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceRetrieveOrder(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start an order on vending machine
         * @param {Alcoholcustomerv1StartOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceStartOrder(body: Alcoholcustomerv1StartOrderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Alcoholcustomerv1StartOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceStartOrder(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrderServiceApi - factory interface
 * @export
 */
export const OrderServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel an order
         * @param {string} uuid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceCancelOrder(uuid: string, body: object, options?: any): AxiosPromise<Alcoholcustomerv1CancelOrderResponse> {
            return localVarFp.orderServiceCancelOrder(uuid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get HPS payment form data
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceGetOrderPaymentData(uuid: string, options?: any): AxiosPromise<V1GetOrderPaymentDataResponse> {
            return localVarFp.orderServiceGetOrderPaymentData(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List customer orders
         * @param {Alcoholcustomerv1ListOrdersRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceListOrders(body: Alcoholcustomerv1ListOrdersRequest, options?: any): AxiosPromise<Alcoholcustomerv1ListOrdersResponse> {
            return localVarFp.orderServiceListOrders(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve order status by uuid
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceRetrieveOrder(uuid: string, options?: any): AxiosPromise<V1RetrieveOrderResponse> {
            return localVarFp.orderServiceRetrieveOrder(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start an order on vending machine
         * @param {Alcoholcustomerv1StartOrderRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceStartOrder(body: Alcoholcustomerv1StartOrderRequest, options?: any): AxiosPromise<Alcoholcustomerv1StartOrderResponse> {
            return localVarFp.orderServiceStartOrder(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderServiceApi - object-oriented interface
 * @export
 * @class OrderServiceApi
 * @extends {BaseAPI}
 */
export class OrderServiceApi extends BaseAPI {
    /**
     * 
     * @summary Cancel an order
     * @param {string} uuid 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    public orderServiceCancelOrder(uuid: string, body: object, options?: AxiosRequestConfig) {
        return OrderServiceApiFp(this.configuration).orderServiceCancelOrder(uuid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get HPS payment form data
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    public orderServiceGetOrderPaymentData(uuid: string, options?: AxiosRequestConfig) {
        return OrderServiceApiFp(this.configuration).orderServiceGetOrderPaymentData(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List customer orders
     * @param {Alcoholcustomerv1ListOrdersRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    public orderServiceListOrders(body: Alcoholcustomerv1ListOrdersRequest, options?: AxiosRequestConfig) {
        return OrderServiceApiFp(this.configuration).orderServiceListOrders(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve order status by uuid
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    public orderServiceRetrieveOrder(uuid: string, options?: AxiosRequestConfig) {
        return OrderServiceApiFp(this.configuration).orderServiceRetrieveOrder(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start an order on vending machine
     * @param {Alcoholcustomerv1StartOrderRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    public orderServiceStartOrder(body: Alcoholcustomerv1StartOrderRequest, options?: AxiosRequestConfig) {
        return OrderServiceApiFp(this.configuration).orderServiceStartOrder(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserServiceApi - axios parameter creator
 * @export
 */
export const UserServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Login by mobile phone
         * @param {Alcoholcustomerv1LoginRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceLogin: async (body: Alcoholcustomerv1LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userServiceLogin', 'body', body)
            const localVarPath = `/api/customer/v1/user/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get my details
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceRetrieveMyDetails: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userServiceRetrieveMyDetails', 'body', body)
            const localVarPath = `/api/customer/v1/user/my-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary issue access token to the user by verify the auth code and mobile number
         * @param {Alcoholcustomerv1VerifyAuthCodeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceVerifyAuthCode: async (body: Alcoholcustomerv1VerifyAuthCodeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userServiceVerifyAuthCode', 'body', body)
            const localVarPath = `/api/customer/v1/user/auth-code-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserServiceApi - functional programming interface
 * @export
 */
export const UserServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Login by mobile phone
         * @param {Alcoholcustomerv1LoginRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userServiceLogin(body: Alcoholcustomerv1LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Alcoholcustomerv1LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userServiceLogin(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get my details
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userServiceRetrieveMyDetails(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RetrieveMyDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userServiceRetrieveMyDetails(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary issue access token to the user by verify the auth code and mobile number
         * @param {Alcoholcustomerv1VerifyAuthCodeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userServiceVerifyAuthCode(body: Alcoholcustomerv1VerifyAuthCodeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Alcoholcustomerv1VerifyAuthCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userServiceVerifyAuthCode(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserServiceApi - factory interface
 * @export
 */
export const UserServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Login by mobile phone
         * @param {Alcoholcustomerv1LoginRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceLogin(body: Alcoholcustomerv1LoginRequest, options?: any): AxiosPromise<Alcoholcustomerv1LoginResponse> {
            return localVarFp.userServiceLogin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get my details
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceRetrieveMyDetails(body: object, options?: any): AxiosPromise<V1RetrieveMyDetailsResponse> {
            return localVarFp.userServiceRetrieveMyDetails(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary issue access token to the user by verify the auth code and mobile number
         * @param {Alcoholcustomerv1VerifyAuthCodeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceVerifyAuthCode(body: Alcoholcustomerv1VerifyAuthCodeRequest, options?: any): AxiosPromise<Alcoholcustomerv1VerifyAuthCodeResponse> {
            return localVarFp.userServiceVerifyAuthCode(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserServiceApi - object-oriented interface
 * @export
 * @class UserServiceApi
 * @extends {BaseAPI}
 */
export class UserServiceApi extends BaseAPI {
    /**
     * 
     * @summary Login by mobile phone
     * @param {Alcoholcustomerv1LoginRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserServiceApi
     */
    public userServiceLogin(body: Alcoholcustomerv1LoginRequest, options?: AxiosRequestConfig) {
        return UserServiceApiFp(this.configuration).userServiceLogin(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get my details
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserServiceApi
     */
    public userServiceRetrieveMyDetails(body: object, options?: AxiosRequestConfig) {
        return UserServiceApiFp(this.configuration).userServiceRetrieveMyDetails(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary issue access token to the user by verify the auth code and mobile number
     * @param {Alcoholcustomerv1VerifyAuthCodeRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserServiceApi
     */
    public userServiceVerifyAuthCode(body: Alcoholcustomerv1VerifyAuthCodeRequest, options?: AxiosRequestConfig) {
        return UserServiceApiFp(this.configuration).userServiceVerifyAuthCode(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VendingMachineServiceApi - axios parameter creator
 * @export
 */
export const VendingMachineServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all available vending machine
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineServiceListVendingMachines: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('vendingMachineServiceListVendingMachines', 'body', body)
            const localVarPath = `/api/customer/v1/vending-machines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Vending Machine details by UUID
         * @param {string} uuid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineServiceRetrieveVendingMachineDetails: async (uuid: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('vendingMachineServiceRetrieveVendingMachineDetails', 'uuid', uuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('vendingMachineServiceRetrieveVendingMachineDetails', 'body', body)
            const localVarPath = `/api/customer/v1/vending-machines/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VendingMachineServiceApi - functional programming interface
 * @export
 */
export const VendingMachineServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VendingMachineServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all available vending machine
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingMachineServiceListVendingMachines(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Alcoholcustomerv1ListVendingMachinesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingMachineServiceListVendingMachines(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve Vending Machine details by UUID
         * @param {string} uuid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingMachineServiceRetrieveVendingMachineDetails(uuid: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RetrieveVendingMachineDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingMachineServiceRetrieveVendingMachineDetails(uuid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VendingMachineServiceApi - factory interface
 * @export
 */
export const VendingMachineServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VendingMachineServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary List all available vending machine
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineServiceListVendingMachines(body: object, options?: any): AxiosPromise<Alcoholcustomerv1ListVendingMachinesResponse> {
            return localVarFp.vendingMachineServiceListVendingMachines(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Vending Machine details by UUID
         * @param {string} uuid 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingMachineServiceRetrieveVendingMachineDetails(uuid: string, body: object, options?: any): AxiosPromise<V1RetrieveVendingMachineDetailsResponse> {
            return localVarFp.vendingMachineServiceRetrieveVendingMachineDetails(uuid, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VendingMachineServiceApi - object-oriented interface
 * @export
 * @class VendingMachineServiceApi
 * @extends {BaseAPI}
 */
export class VendingMachineServiceApi extends BaseAPI {
    /**
     * 
     * @summary List all available vending machine
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingMachineServiceApi
     */
    public vendingMachineServiceListVendingMachines(body: object, options?: AxiosRequestConfig) {
        return VendingMachineServiceApiFp(this.configuration).vendingMachineServiceListVendingMachines(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Vending Machine details by UUID
     * @param {string} uuid 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingMachineServiceApi
     */
    public vendingMachineServiceRetrieveVendingMachineDetails(uuid: string, body: object, options?: AxiosRequestConfig) {
        return VendingMachineServiceApiFp(this.configuration).vendingMachineServiceRetrieveVendingMachineDetails(uuid, body, options).then((request) => request(this.axios, this.basePath));
    }
}


